import React from 'react';
import { LuBot } from 'react-icons/lu';

interface AgentAuthorBadgeProps {
  clientName?: string; // MCP client's self-reported name, e.g. "Claude Code" — falls back to a generic label when absent
  // 'written' (default) for task/comment creation (MVPB-47); 'changed' for a changelog/activity
  // entry (MVPB-25) — same badge, same color, just the correct verb for what actually happened.
  action?: 'written' | 'changed';
}

// Badge for content created/changed via the MCP server (Claude Code, Claude Desktop, or any other
// MCP client). Label stays fixed at "{Verb} via MCP" (clientName only surfaces in the tooltip) and
// uses `badge-info` rather than `badge-primary` specifically so it doesn't read as the same thing
// as the in-app AI copilot's own "mFlow" comment badge — that one signals mFlow's built-in agent,
// this one signals an external MCP client acting on the user's behalf. See MVPB-47.
export const AgentAuthorBadge: React.FC<AgentAuthorBadgeProps> = ({ clientName, action = 'written' }) => {
  const verb = action === 'changed' ? 'Changed' : 'Written';
  const tooltipVerb = action === 'changed' ? 'Changed' : 'Created';
  return (
    <span
      className="badge badge-info badge-xs gap-1"
      title={clientName ? `${tooltipVerb} via MCP by ${clientName}` : `${tooltipVerb} via MCP by an AI agent`}
    >
      <LuBot size={10} />
      {verb} via MCP
    </span>
  );
};
